export enum ButtonColorEnum {
  common = 'common',
  primary = 'primary',
  success = 'success',
  attention = 'attention',
  warning = 'warning',
  info = 'info',
}
